import React                  from 'react';
import RoxxRacingHeader       from './img/Header.jpg';
import RoxxRacingMobileHeader from './img/RoxxRacing-Mobile-Header.jpg';
import TicketCount            from './img/Ticket-Icon.png';
import {AppConsumer}          from './App.context';

const RRHeader = () => (
	<AppConsumer>
		{({buyInfo}) => (
			<div className="roxxracing_primaryheader">
				<a className="header-fix" href="/tickets">
					<img className="roxxracing_primaryheader-image" src={RoxxRacingHeader} alt="Roxx-Racing Header" />
					<img className="roxxracing_mobileheader-image" src={RoxxRacingMobileHeader} alt="Roxx-Racing Header" />
				</a>
				{buyInfo && buyInfo.boughtItems && buyInfo.boughtItems[3] && buyInfo.boughtItems[3] > 0 &&
				<span className="roxxracing_primaryheader__ticket-count">
					<img className="roxxracing_primaryheader__ticket-image" src={TicketCount} alt="Roxx-Racing Ticket Anzahl" />
					<span className="roxxracing_primaryheader__ticket-text">Du besitzt:<br /> <strong>{buyInfo.boughtItems[3]} TICKETS</strong></span>
				</span>}
			</div>
		)}
	</AppConsumer>
);

export default RRHeader;




// WEBPACK FOOTER //
// ./src/RoxxRacingHeader.js